import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=ce2c11c2&scoped=true"
const script = {}

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=ce2c11c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2c11c2"]])

export default __exports__